<template>
  <vs-card class="pl-5 pt-5 pr-1 m-0">
    <div>
      <a href="#" @click="$emit('changeTab','ComponentProgressByUser')">
        <h4 class="title-report font-semibold">Task Progress by User</h4>
      </a>
      <p class="text-base font-medium">User progress against their assigned tasks.<a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentProductivityByUser')">
        <h4 class="title-report font-semibold">Task Productivity by User</h4>
      </a>
      <p class="text-base font-medium">Summary of tasks grouped by user.<a href="#"></a></p>
    </div>
  </vs-card>
</template>

<script>
export default {
name: "TaskReport"
}
</script>

<style scoped>

</style>
